import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';
import { PersonIcon } from 'src/icons/PersonIcon';
import { ProjectRole } from 'src/model/api/v2/data-contracts';
import { InviteUserForm } from 'src/pages/ProjectUsersPage/components/InviteUserForm';
import { AddressRequiredDialog } from 'src/pages/ProjectUsersPage/components/AddressRequiredDialog';
import { ts } from 'src/utils/translate';

type Props = {
    projectId: number;
    roles: ProjectRole[];
    hasAddress: boolean;
    readOnly: boolean;
};

export const InviteSection = ({ projectId, roles, hasAddress, readOnly }: Props) => {
    const navigate = useNavigate();
    const [formOpen, setFormOpen] = useState(false);
    const [addressDialogOpen, setAddressDialogOpen] = useState(false);

    const handleInviteClick = () => {
        if (hasAddress) {
            setFormOpen(true);
        } else {
            setAddressDialogOpen(true);
        }
    };

    return (
        <>
            {formOpen ? (
                <InviteUserForm
                    projectId={projectId}
                    roles={roles}
                    disabled={readOnly}
                    onClose={() => setFormOpen(false)}
                />
            ) : (
                <Button
                    variant="outlined"
                    startIcon={<PersonIcon />}
                    onClick={handleInviteClick}
                    sx={{ minHeight: 120 }}
                >
                    {ts('project_users_invite', 'Invite')}
                </Button>
            )}
            <AddressRequiredDialog
                open={addressDialogOpen}
                onClose={() => setAddressDialogOpen(false)}
                onGoThere={() => navigate(`/projects/${projectId}`)}
            />
        </>
    );
};
